<template>
  <div>
    <label v-if="label" :for="name">{{ label }}</label>
    <textarea
      :rows="rows"
      class="form-control"
      :class="[classObject, classname]"
      :name="name"
      :id="name"
      :placeholder="placeholder"
      :step="step"
      :value="value"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :maxlength="maxlength"
      :data-always-show="maxlengthShow"
      v-on:input="updateValue($event.target.value)"
    />
    <small v-if="helper" class="form-text text-muted">{{ helper }}</small>
    <div v-if="error" class="invalid-feedback animated fadeIn">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    rows: {
      type: String,
      default: 2
    },
    classname: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    step: {
      type: String,
    },
    value: {},
    autocomplete: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    helper: {
      type: String,
    },
    maxlength: {
      type: String,
    },
    maxlengthShow: {
      type: Boolean
    }
  },
  computed: {
    error: function() {
      if (this.$parent && this.$parent.errors) {
        if (this.$parent.errors[this.name]) {
          return this.$parent.errors[this.name][0];
        }
      }
    },
    classObject: function() {
      return {
        'is-invalid': this.error ? true : false,
      };
    },
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value);
    },
  },
};
</script>
